import { Injectable } from '@angular/core';
import { Query, gql } from 'apollo-angular';

import { CartJob } from '../models/cart-job.model';

@Injectable({
  providedIn: 'root',
})
export class GetCartJobGQL extends Query<{ cart: CartJob }> {
  override document = gql`
    query getCartJob {
      cart {
        jobQuote
        fulfillmentStoreNumber
        job {
          key
          name
          accountNumber
          countryCode
          isActive
          jobType
          salesRep {
            email
          }
          secondarySalesRep {
            email
          }
        }
        totalItemsQuantity
      }
    }
  `;
}
